import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import {resources} from "./locales/resources";

i18n
    .use(initReactI18next)
    .init({
        lng: 'en',
        fallbackLng: 'en',
        debug: true,
        resources,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        react: {
            wait: true
        }
    });


export default i18n;
